<script lang="ts">
	import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
	import { Switch } from '@skeletonlabs/skeleton-svelte';
	import Fa from 'svelte-fa';
	import { browser } from '$app/environment';

	const STORAGE_KEY = 'supertip:theme-mode';

	let checked = $derived(browser && document.documentElement.classList.contains('dark'));

	const onCheckedChange = (event: { checked: boolean }) => {
		checked = event.checked;
		document.documentElement.classList.toggle('dark', checked);
		document.documentElement.style.colorScheme = checked ? 'dark' : 'light';
		localStorage.setItem(STORAGE_KEY, checked ? 'dark' : 'light');
	};
</script>

<Switch class="theme-toggle" {checked} {onCheckedChange}>
	<Switch.Control
		class="preset-filled-surface-100-900 data-[state=checked]:preset-filled-surface-500 dark:preset-filled-surface-500"
	>
		<Switch.Thumb>
			<Fa icon={faSun} size="1x" class="dark:hidden" />
			<Fa icon={faMoon} size="1x" class="hidden dark:block" />
		</Switch.Thumb>
	</Switch.Control>
	<Switch.HiddenInput aria-label="Toggle dark mode" />
</Switch>
